/**
 * Import
 * - Libraries
 */
import { connect } from 'react-redux'
import { get } from 'lodash'
/**
 * Import
 * - Store
 */
import { RootState } from '../../../store'

/**
 * Import
 * - Actions
 */
import { setStep01, resetQuotes, setStep01Renewals, getRenewalVariation } from '../../../actions'

/**
 * Import
 * - Page component
 */
import Step01 from '../../../components/pages/Quote/Step01/Step01'

const mapStateToProps = (state: RootState, props: any) => {
    return {
        quote: state.quote,
        editQuote: props.editQuote || false,
        fullQuote: get(state.quote, 'full.response.quote', {}),
    }
}

export default connect(mapStateToProps, {
    setStep01: setStep01,
    setStep01Renewals: setStep01Renewals,
    resetQuotes: resetQuotes,
    getRenewalVariation,
})(Step01)



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/containers/pages/Quote/Step01.tsx